import { useContext } from 'react'
import { PropertyContext } from 'src/context/property'
import { PropertyAPIResponse as PropertyType } from 'src/types/property'

export const useProperty = () => {
  const property: PropertyType | null = useContext(PropertyContext)

  if (!property) {
    throw new Error('Missing PropertyContext provider or value is null')
  }

  return property
}
